<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Loading from "@/components/c-loading";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
import { penaltySetting } from "../../../../../services/managements/penaltysettings/penaltysetting.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Penalty Setting",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Penalty Setting",
      breadCrumb: {},

      penalty_setting: {},
      valueId: 0,
      valueExcept: 0,
      valueAmount: 0,
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      penaltySetting.getOne(id)
        .then(response => {
        
          this.fetchingStats = true;
          this.penalty_setting = response.data;
          this.valueId = this.penalty_setting.id;
          this.valueExcept = this.penalty_setting.day_except;
          this.valueAmount = this.penalty_setting.amount;
        });
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      let dataSubmit = {
        day_except: this.valueExcept,
        amount: this.valueAmount,
      };

      console.log(JSON.stringify(dataSubmit))

      if(this.isAdd) {
        penaltySetting.insert(dataSubmit).then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            this.clearForm();
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-setting-penalty-setting"
                });
              } 
            });
          }
        });
      } 
      else {
        penaltySetting.update(this.$route.params.id, dataSubmit).then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-setting-penalty-setting"
                });
              } 
            });

          }
        });
      }

    },
    clearForm: function() {
      this.valueExcept = 0;
      this.valueAmount = 0;
    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('manage.penalty-setting.text'),
        href: '/manage/setting/service-type',
      }, {
        text: this.isAdd ? $t('manage.penalty-setting.edit') : $t('manage.penalty-setting.edit'),
        active: true
      }]" :title="this.isAdd ? $t('manage.penalty-setting.edit') : $t('manage.penalty-setting.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('manage.penalty-setting.text'),
        href: '/manage/setting/service-type',
      }, this.breadCrumb]" :title="this.isAdd ? $t('manage.service-type.new') : $t('manage.penalty-setting.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                
                <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'except'"
                    v-model="valueExcept"
                    :require="true"
                    :label="'manage.penalty-setting.except-day'"  />
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'amount'"
                    v-model="valueAmount"
                    :require="true"
                    :label="'manage.penalty-setting.amount'"  />
                </div>
              </div>


              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>